import React from "react";
import {Link} from "react-router-dom";
import {useProfile} from "../../context/ProfileContext";

const EditIcon = () => {
    const {profile, isLoggedUser} = useProfile();

    if (!profile || !isLoggedUser) {
        return <></>
    }

    return (
        <span className='edit-icon'><Link to={'/profile/edit'}><i className='fa fa-fw fa-edit ms-1'></i></Link></span>
    )
}

export default EditIcon;
